import { useContext } from 'react';
import { BottomTabBarHeightContext } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function useTabBarInset(): number {
	const tabBarHeight = useContext(BottomTabBarHeightContext);
	const insets = useSafeAreaInsets();

	if (tabBarHeight === undefined || tabBarHeight === 0) {
		return insets.bottom;
	}

	return tabBarHeight;
}
